import styles from "./LoginBox.module.scss";
import LoginRequiredSection from "Explore/Components/LoginRequired";

const LoginBox = ({ title }) => {
  

  return (
    <div className={styles["box"]}>
      <LoginRequiredSection title={title}/>
    </div>
  );
};

export default LoginBox;
